import { render, staticRenderFns } from "./ContentTableEdit.vue?vue&type=template&id=01206564&"
import script from "./ContentTableEdit.vue?vue&type=script&lang=js&"
export * from "./ContentTableEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports